export const airtableFieldIds = {
  estado: 'fldsnmOQJ8X0vNlt5',
  enviadoPorUsuario: 'fldOgstvaN4RXRgK3',
  metodoPago: 'fldQjc5XZWiymcKiF',
  contacto: 'fld63Q3zN6QRjTQ0O',
  pendientePago: 'fldZRPkTd2SlAFear',
  nombreRazon: 'fld29TD7x1ALk6E4G',
  correo: 'fldHmSVVPesohlW1X',
  telefono: 'flddCkRbmxs59Qm7C',
  whatsapp: 'fldE8mfwquViuEqjb',
  total: 'fldcoJRrEa1hVFzU3',
  notasInternas: 'flduq2zqWt4fgOv3u',
  comentarios: 'fldmHsq3muxXhqQ5x',
  periodo: 'fldWhWvgfc2sxWwIo',
  concepto: 'fldvFmeTabmGqPyf3',
  formaPago: 'fld63P7suT1BYQ225',
  tipoContribuyente: 'fld72dcCVnurruO8s',
  rfcPm: 'fldTBobAG4gQErYtg',
  rfcPf: 'fldbGeWg8zgQfDJRr',
  idFiscal: 'flduTY8aoidg4SA9k',
  codigoPostal: 'fldgk2OyUfuFmieh2',
  numeroTicket: 'fldLCGzLcZL1zaJxc',
  clienteAsociado: 'fldfy2smRxyH7bAF1',
  regimenFiscal: 'fldC8YEArmqYXXee6',
  usoCfdi: 'fldyWVfL2K4oQJgQu',
  telefonoValidacion: 'fldJA8Crwi9HYArfz',
  constanciaAdjunta: 'fldoA7mreeMBbF2px',
  ticketAdjunto: 'fldQFrg2opVtEIy6q'
};

export const formaPagoOptions = [
  'Transferencia',
  'Tarjeta de Crédito (TDC)',
  'Tarjeta de Débito (TDD)',
  'Cheque',
  'Efectivo'
];

export const defaultCreateForm = {
  clientName: '',
  clienteAsociado: '',
  tipoContribuyente: 'Persona Moral (Empresa)',
  rfcPm: '',
  rfcPf: '',
  idFiscal: '',
  codigoPostal: '',
  regimenFiscal: '',
  usoCfdi: '',
  numeroTicket: '',
  periodo: '',
  constanciaFiles: [],
  ticketFiles: [],
  email: '',
  phone: '',
  telefonoValidacion: '',
  whatsapp: '',
  contact: 'Correo Electrónico',
  metodoPago: 'Pago en una sola exhibición (PUE)',
  formaPago: 'Transferencia',
  total: '',
  concepto: '',
  estado: 'Pendiente',
  comentarios: '',
  notasInternas: ''
};

export const FALLBACK_CLIENTS_TABLE_ID = 'tblC5Jn5qbpiIEh2V';

export const clientFields = {
  enlaceFormulario: 'Enlace Formulario'
};

export const mockClientOptions = [
  { id: 'recMockAlpha', alias: 'ALFONSO DIAZ', empresa: 'ALFONSO DIAZ', nombreComercial: 'MAXIMILIANA', idCliente: 'DIRA9' },
  { id: 'recMockBravo', alias: 'CUU AC SERVICIOS', empresa: 'CUU AC SERVICIOS 2020', nombreComercial: 'UNIMERCA', idCliente: 'CUU20' },
  { id: 'recMockCharlie', alias: 'HOME MAX', empresa: 'HOME MAX', nombreComercial: 'HOME MAX', idCliente: 'HOME' },
  { id: 'recMockDelta', alias: 'INTER HOUSE', empresa: 'INTER HOUSE', nombreComercial: 'INTER HOUSE', idCliente: 'INTER' }
];

export const REGIMENES_TABLE_ID = 'tbleGmNMolawHPrHk';
export const USOS_CFDI_TABLE_ID = 'tbldRkWjQOjeuDzx1';

export const REGIMEN_TIPO_FIELD_ID = 'fldHudgjp4v3n0J42';
export const USO_CFDI_TIPO_FIELD_ID = 'fldqt68dFBs5EgjZf';
